import {
  Box,
  CloseButton,
  Divider,
  Flex,
  Icon,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ROUTE_LINK_ITEMS } from "../constants/index";

const NavItem = ({ icon, children, selected, ...rest }) => {
  return (
    <Box
      as="a"
      style={{ textDecoration: "none" }}
      _focus={{ boxShadow: "none" }}
    >
      <Flex
        align="center"
        p="4"
        mx="4"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        bg={useColorModeValue(selected ? "grey" : "black", "gray.500")}
        _hover={{
          bg: "gray.600",
          color: "white",
        }}
        {...rest}
      >
        {icon && (
          <Icon
            mr="4"
            fontSize="16"
            _groupHover={{
              color: "white",
            }}
            as={icon}
          />
        )}
        {children}
      </Flex>
    </Box>
  );
};

const SidebarContent = ({ onClose, ...rest }) => {
  const [selected, setSelected] = useState();
  const location = useLocation();

  useEffect(() => {
    const selectedData = ROUTE_LINK_ITEMS.find(
      (obj) => obj.url === location?.pathname
    );
    setSelected(selectedData);
  }, [location]);
  return (
    <Box
      transition="3s ease"
      bg={useColorModeValue("black", "gray.900")}
      color={useColorModeValue("whitesmoke", "gray.900")}
      borderRight="1px"
      borderRightColor={useColorModeValue("gray.200", "gray.700")}
      w={{ base: "full", md: 60 }}
      pos="fixed"
      h="full"
      {...rest}
    >
      <Flex
        h="20"
        alignItems="center"
        justifyContent="space-between"
        background={"white"}
        padding={"40px"}
        paddingLeft={"20px"}
      >
        <Box className="ecomlogo">
          <Image
            src="https://ecom360.club/wp-content/uploads/2021/11/ecom360_-Logo.png"
            alt="Ecom360 Partners"
          />
        </Box>

        <CloseButton
          color={"black"}
          display={{
            base: "flex",
            md: "none",
          }}
          onClick={onClose}
        />
      </Flex>
      <Divider />
      <Box marginTop="10px">
        {ROUTE_LINK_ITEMS.map((link) => (
          <Link to={link.url}>
            <NavItem
              key={link.name}
              icon={link.icon}
              selected={selected?.url === link?.url ? true : false}
            >
              {link.name}
            </NavItem>
          </Link>
        ))}
      </Box>
    </Box>
  );
};

export default SidebarContent;
